import { render, staticRenderFns } from "./TasksBell.vue?vue&type=template&id=72002bcf&scoped=true"
import script from "./TasksBell.vue?vue&type=script&lang=js"
export * from "./TasksBell.vue?vue&type=script&lang=js"
import style0 from "./TasksBell.vue?vue&type=style&index=0&id=72002bcf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72002bcf",
  null
  
)

export default component.exports